export const TABLE = 'TableStore'
export const ID = 'id'
export const AFTER_SET_VALUE = 'afterSetValue'
export const _STATUS = '_status'
export const DataState = {
  Update : 'Update',
  Insert : 'Insert',
  Delete: 'Delete',
  Unchanged: 'Unchanged'
}
export const singleReferNullableType = ['undefined', undefined, null, 'null']
export const DataChanged = [DataState.Delete, DataState.Insert, DataState.Update]
export interface ValueObj {
  [key: string]: string | number | ValueObj
}
export const MULTIPLE = "multiple"

export const isString = ()=> {

}

const REFER_INPUT_PC = 'ReferInputPc'
const REFER_INPUT = 'ReferInput'
const NUMBER_INPUT = 'InputNumber'
export const CHARACTERISTICS = 'Characteristics'
export const isRefer = (controlType?: string)=> {
  return controlType == REFER_INPUT_PC || controlType == REFER_INPUT
}
// 特征
export const isCharacter = (column: ColumnsType)=> {
  return column.controlType == CHARACTERISTICS
}
// 数值
export const isNumber = (controlType?: string)=> {
  return controlType == NUMBER_INPUT
}



// 类型定义专用
export interface ColumnsType {

  storeAlias: string; // store 别名 元数据
  alias?: string; //store 别名 字段
  field?: string | undefined; // ypd 保存字段
  key?: string; //
  dataIndex?: number;
  defaultValue?:string | object | Array<any> ;
  isMasterOrg?: boolean;// 主组织
  // 行类型
  controlType?: string;
  refReturnArr?: string;
  refReturn?:[]
  caption?: string; // 标题，给返回验证对象使用
  disabled?: boolean; // 禁用
  visible?: boolean; // 显示
  readOnly?: boolean; // 只读
  required?: boolean; // 必填
  storeField?: string;
  tableStoreKey?:string; // 多选参照
  dataSourceAlias?:string;// 数据源别名
  selectType?:string;// 选择类型
  virtualField?:boolean
  characterEffects?: string[]
  bizType?: string
  type?: string
  characterId?: string,
  stateType?: string //"character",
  tableHeader?: any
}
